
import React, { useEffect, useState } from "react";
import {
  Card,
  Row,
  Col,
  Typography,
  Input,
  Button,
  Space,
  message,
  ColorPicker,
  Select,
} from "antd";
import {
  CopyOutlined,
  CodeOutlined,
  PhoneOutlined,
  SaveOutlined,
  ReloadOutlined,
} from "@ant-design/icons";
import { useSelector } from "react-redux";
import api from "../../../core/axios/axiosInstance";
import "./ScriptGenerator.css";
import { Link } from "react-router-dom";

const { Title, Text } = Typography;
const { TextArea } = Input;

let _cache = { extOptions: null, generatedScript: null, loadedAt: null };

const ScriptGenerator = () => {
  const profile = useSelector((state) => state.profile);
console.log(profile,"profiledata");


  const getDefaultArray = (arr) =>
    Array.isArray(arr) && arr.length > 0 ? arr : [""];

  const [formData, setFormData] = useState({
    themeColor: profile?.popupSettings?.themeColor || "#2249aa",
    headingColor: profile?.popupSettings?.headingColor || "#2249aa",
    floatingButtonColor: profile?.popupSettings?.floatingButtonColor || "#2249aa",
    popupHeading: profile?.popupSettings?.popupHeading || "📞 Request a Call Back",
    popupText:
      profile?.popupSettings?.popupText ||
      "Enter your phone number and we'll call you back in 30 seconds!",
    calltoaction: profile?.popupSettings?.calltoaction || "Call Me",
    phoneIconColor: profile?.popupSettings?.phoneIconColor || "black",

    allowedOriginPopup: getDefaultArray(
      profile?.popupSettings?.allowedOriginPopup
    ),

    allowedOriginContactForm: getDefaultArray(
      profile?.popupSettings?.allowedOriginContactForm
    ),

    restrictedUrls: getDefaultArray(
      profile?.popupSettings?.restrictedUrls
    ),

    fieldName: profile?.popupSettings?.fieldName || "",
  });


  const [extOptions, setExtOptions] = useState(_cache.extOptions || []);
  const [selectedExtensionNumber, setSelectedExtensionNumber] = useState(
    () => profile?.popupSettings?.selectedExtensionNumber || profile?.PBXDetails?.PBX_EXTENSION_NUMBER || ""
  );

  // Generated script state
  const [generatedScript, setGeneratedScript] = useState(_cache.generatedScript || "");
  const [isSaving, setIsSaving] = useState(false);
  const [isGenerating, setIsGenerating] = useState(false);
  const [isRefreshing, setIsRefreshing] = useState(false);
  const [isInitialLoad, setIsInitialLoad] = useState(!_cache.generatedScript);

  // Handle input changes
  const handleInputChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  // Handle color change from ColorPicker
  const handleColorChange = (field, color) => {
    // The color parameter from ColorPicker is an object, get hex value
    const hexColor = color.toHexString();
    setFormData((prev) => ({
      ...prev,
      [field]: hexColor,
    }));
  };


  const addOrigin = () => {
    setFormData((prev) => ({
      ...prev,
      allowedOriginPopup: [...prev?.allowedOriginPopup, ""],
    }));
  };

  const updateOrigin = (index, value) => {
    const updated = [...formData?.allowedOriginPopup];
    updated[index] = value;
    setFormData((prev) => ({
      ...prev,
      allowedOriginPopup: updated,
    }));
  };

  const removeOrigin = (index) => {
    setFormData((prev) => ({
      ...prev,
      allowedOriginPopup: prev?.allowedOriginPopup?.filter((_, i) => i !== index),
    }));
  };

  const addContactFormOrigin = () => {
    setFormData((prev) => ({
      ...prev,
      allowedOriginContactForm: [...prev.allowedOriginContactForm, ""],
    }));
  };

  const updateContactFormOrigin = (index, value) => {
    const updated = [...formData.allowedOriginContactForm];
    updated[index] = value;
    setFormData((prev) => ({
      ...prev,
      allowedOriginContactForm: updated,
    }));
  };

  const removeContactFormOrigin = (index) => {
    setFormData((prev) => ({
      ...prev,
      allowedOriginContactForm: prev.allowedOriginContactForm.filter(
        (_, i) => i !== index
      ),
    }));
  };

  // Copy only script attributes (without <script> tag)
  const handleCopyAttributesOnly = () => {
    if (!generatedScript) return;

    // Match opening script tag
    const match = generatedScript.match(/<script\s+([^>]*)>/i);

    if (match && match[1]) {
      const attributes = match[1].trim();
      navigator.clipboard.writeText(attributes);
      message.success("Script attributes copied to clipboard!");
    } else {
      message.error("No script attributes found");
    }
  };


  // Save settings only
  const handleSaveSettings = async () => {
    setIsSaving(true);
    try {
console.log(formData,"jkhgjfhgdfhj");

      const response = await api.post("/api/script/generate", {
        ...formData,
        selectedExtensionNumber,
        onlySaveSettings: true,
      });

      if (response.data) {
        message.success("Settings saved successfully!");
        const scriptText =
          typeof response.data === "string"
            ? response.data
            : response.data.script || response.data.scriptTag || "";
        if (scriptText) {
          setGeneratedScript(scriptText.trim());
        }
        else {
          // message.error("Failed to generate script");
          message.error("The phone extension is disabled. Please contact administrator");
        }
      } else {
        message.error("Failed to save settings");
      }
    } catch (error) {
      console.error("Error saving settings:", error);
      message.error("The phone extension is disabled. Please contact administrator");

    } finally {
      setIsSaving(false);
    }
  };

  // Generate script
  const handleGenerateScript = async () => {
    setIsGenerating(true);
    try {
      const response = await api.post("/api/script/generate", { ...formData, selectedExtensionNumber });
      if (response.data) {
        const scriptText =
          typeof response.data === "string"
            ? response.data
            : response.data.script || response.data.scriptTag || "";

        if (scriptText) {
          const trimmed = scriptText.trim();
          setGeneratedScript(trimmed);
          _cache.generatedScript = trimmed;
          _cache.loadedAt = Date.now();
        } else {
          message.error("Failed to generate script");
        }
      } else {
        message.error("Failed to generate script");
      }
    } catch (error) {
      console.error("Error generating script:", error);
    } finally {
      setIsGenerating(false);
    }
  };

  // Copy script to clipboard
  const handleCopyScript = () => {
    if (generatedScript) {
      navigator.clipboard.writeText(generatedScript);
      message.success("Script copied to clipboard!");
    }
  };

  const loadExtensions = async (forceRefresh = false) => {
    if (!forceRefresh && _cache.extOptions) {
      setExtOptions(_cache.extOptions);
      return;
    }
    try {
      const res = await api.get("/api/script/managed-extensions");
      const opts = (res.data.extensions || []).map((e) => ({
        value: e.extensionNumber,
        label: e.label || `Ext ${e.extensionNumber}`,
      }));
      setExtOptions(opts);
      _cache.extOptions = opts;
      const saved = profile?.popupSettings?.selectedExtensionNumber;
      if (saved && opts.some((o) => o.value === saved)) {
        setSelectedExtensionNumber(saved);
      } else if (opts.length > 0) {
        setSelectedExtensionNumber(opts[0].value);
      } else {
        setSelectedExtensionNumber("");
      }
    } catch {}
  };

  const handleRefresh = async () => {
    setIsRefreshing(true);
    setIsInitialLoad(true);
    _cache = { extOptions: null, generatedScript: null, loadedAt: null };
    await loadExtensions(true);
    await handleGenerateScript();
    setIsInitialLoad(false);
    setIsRefreshing(false);
  };

  // Fetch all extensions managed by this company admin (own pool + agent extensions)
  useEffect(() => {
    loadExtensions();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // Auto-generate script on first mount if not cached
  useEffect(() => {
    if (!_cache.generatedScript) {
      handleGenerateScript().finally(() => setIsInitialLoad(false));
    }
  }, []);



  useEffect(() => {
    if (profile?.popupSettings) {
      setFormData((prev) => ({
        ...prev,
        allowedOriginPopup: getDefaultArray(profile.popupSettings.allowedOriginPopup),
        allowedOriginContactForm: getDefaultArray(profile.popupSettings.allowedOriginContactForm),
        restrictedUrls: getDefaultArray(profile.popupSettings.restrictedUrls),
        fieldName: profile.popupSettings.fieldName || "",
      }));
    }
  }, [profile]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="row">
          <div className="col-md-12">
            <div className="card">

              <div className="card-body">
                <Row gutter={[24, 24]}>
                  <Col xs={24} lg={12}>
                    <Card
                      title={
                        <Space>
                          <CodeOutlined />
                          <span>Script Configuration</span>
                        </Space>
                      }
                      extra={
                        <Button
                          icon={<ReloadOutlined />}
                          loading={isRefreshing}
                          onClick={handleRefresh}
                          size="small"
                        >
                          Refresh
                        </Button>
                      }
                      bordered={false}
                    >
                      {isInitialLoad ? (
                        <Space direction="vertical" size="small" style={{ width: "100%" }}>
                          <div>
                            <Text strong style={{ display: "block", marginBottom: 6 }}>Receive Calls On</Text>
                            <div className="contact-skel" style={{ width: "100%", height: 40, borderRadius: 6 }} />
                          </div>
                          <div>
                            <Text type="secondary" style={{ fontSize: 12, display: "block", marginBottom: 6 }}>Popup Text</Text>
                            <div className="contact-skel" style={{ width: "100%", height: 40, borderRadius: 6 }} />
                          </div>
                          <div>
                            <Text type="secondary" style={{ fontSize: 12, display: "block", marginBottom: 6 }}>Call to Action Button</Text>
                            <div className="contact-skel" style={{ width: "100%", height: 40, borderRadius: 6 }} />
                          </div>
                          <div>
                            <Text strong>Phone Icon Color</Text>
                            <div style={{ display: "flex", gap: 8, marginTop: 8 }}>
                              <div className="contact-skel" style={{ width: 80, height: 32, borderRadius: 6 }} />
                              <div className="contact-skel" style={{ width: 80, height: 32, borderRadius: 6 }} />
                            </div>
                          </div>
                          <div>
                            <Text strong>Website URL</Text>
                            <div className="contact-skel" style={{ width: "100%", height: 40, borderRadius: 6, marginTop: 8 }} />
                          </div>
                          <div>
                            <Text strong>Contact Form URL</Text>
                            <div className="contact-skel" style={{ width: "100%", height: 40, borderRadius: 6, marginTop: 8 }} />
                          </div>
                          <div>
                            <Text strong style={{ display: "block", marginBottom: 6 }}>Field Name</Text>
                            <div className="contact-skel" style={{ width: "100%", height: 40, borderRadius: 6 }} />
                          </div>
                          <div className="d-flex justify-content-around">
                            <div>
                              <Text strong style={{ display: "block", marginBottom: 8 }}>Floating Button</Text>
                              <div className="contact-skel" style={{ width: 80, height: 40, borderRadius: 6 }} />
                            </div>
                            <div>
                              <Text strong style={{ display: "block", marginBottom: 8 }}>Button</Text>
                              <div className="contact-skel" style={{ width: 80, height: 40, borderRadius: 6 }} />
                            </div>
                            <div>
                              <Text strong style={{ display: "block", marginBottom: 8 }}>Title</Text>
                              <div className="contact-skel" style={{ width: 80, height: 40, borderRadius: 6 }} />
                            </div>
                          </div>
                          <div className="contact-skel" style={{ width: "100%", height: 44, borderRadius: 6 }} />
                          <div>
                            <Text strong style={{ display: "block", marginBottom: 8 }}>Generated Script</Text>
                            <div className="contact-skel" style={{ width: "100%", height: 120, borderRadius: 6 }} />
                          </div>
                        </Space>
                      ) : (
                      <Space
                        direction="vertical"
                        size="small"
                        style={{ width: "100%" }}
                      >
                        {extOptions.length > 0 && (
                          <div style={{ marginBottom: 4 }}>
                            <Text strong style={{ display: "block", marginBottom: 6 }}>
                              Receive Calls On
                            </Text>
                            <Select
                              value={selectedExtensionNumber || undefined}
                              onChange={(val) => setSelectedExtensionNumber(val)}
                              options={extOptions}
                              style={{ width: "100%" }}
                              placeholder="Select extension"
                              size="large"
                            />
                            <Text type="secondary" style={{ fontSize: 12, display: "block", marginTop: 4 }}>
                              Incoming calls from the widget will ring this extension. Change anytime — no need to regenerate the script.
                            </Text>
                          </div>
                        )}

                        {/* <div className="custom-floating-label">
                          <input
                            type="text"
                            readOnly
                            value={formData.popupHeading}
                            placeholder="Enter popup heading"
                            onChange={(e) =>
                              handleInputChange("popupHeading", e.target.value)
                            }
                            style={{
                              fontSize: 14,
                              marginTop: -1,
                              cursor: "not-allowed",
                            }}
                          />
                          <label htmlFor="email">Popup Heading</label>
                        </div> */}


                        <div className="custom-floating-label">
                          <input
                            type="text"
                            readOnly
                            value={formData.popupText}
                            placeholder="Enter popup text"
                            onChange={(e) =>
                              handleInputChange("popupText", e.target.value)
                            }
                            style={{
                              fontSize: 14,
                              marginTop: -1,
                              cursor: "not-allowed",
                            }}
                          />
                          <label htmlFor="email">Popup Text</label>
                        </div>

                        <div className="custom-floating-label">
                          <input
                            type="text"
                            readOnly
                            value={formData.calltoaction}
                            placeholder="Enter call to action"
                            onChange={(e) =>
                              handleInputChange("calltoaction", e.target.value)
                            }
                            style={{
                              fontSize: 14,
                              marginTop: -1,
                              cursor: "not-allowed",
                            }}
                          />
                          <label htmlFor="email">Call to Action Button</label>
                        </div>

                        <div style={{ marginTop: -10 }}>
                          <Text strong>Phone Icon Color</Text>
                          <div style={{ marginTop: 8 }}>
                            <Space>
                              <Button
                                type={
                                  formData.phoneIconColor === "black"
                                    ? "primary"
                                    : "default"
                                }
                                onClick={() =>
                                  handleInputChange("phoneIconColor", "black")
                                }
                              >
                                Black
                              </Button>
                              <Button
                                type={
                                  formData.phoneIconColor === "white"
                                    ? "primary"
                                    : "default"
                                }
                                onClick={() =>
                                  handleInputChange("phoneIconColor", "white")
                                }
                              >
                                White
                              </Button>
                            </Space>
                          </div>
                          <Text
                            type="secondary"
                            style={{
                              fontSize: "12px",
                              display: "block",
                              marginTop: 4,
                              marginBottom: 4,
                            }}
                          >
                            Selected: {formData.phoneIconColor}
                          </Text>
                        </div>

                        <div>
                          <div className="d-flex justify-content-between align-items-center">
                            <Text strong className="flex-1">Website URL</Text>
                            <Button type="dashed" onClick={addOrigin}>
                              + Add another website
                            </Button>

                          </div>
                          <div>

                            <Space direction="vertical" style={{ width: "100%", marginTop: 8 }}>
                              {formData?.allowedOriginPopup?.map((origin, index) => (
                                <div
                                  key={index}
                                  style={{
                                    display: "flex",
                                    gap: 8,
                                    width: "100%",
                                    alignItems: "center"
                                  }}
                                >
                                  <Input
                                    size="large"
                                    value={origin}
                                    placeholder="https://example.com"
                                    onChange={(e) => updateOrigin(index, e.target.value)}
                                    style={{ width: "100%" }}
                                  />

                                  {formData.allowedOriginPopup.length > 1 && (
                                    <Button danger onClick={() => removeOrigin(index)}>
                                      Remove
                                    </Button>
                                  )}
                                </div>

                              ))}


                            </Space>
                          </div>

                        </div>






                        <div>
                          <div className="d-flex justify-content-between align-items-center">
                            <Text strong>Contact Form URL</Text>
                            <Button type="dashed" onClick={addContactFormOrigin}>
                              + Add another URL
                            </Button>
                          </div>

                          <Space direction="vertical" style={{ width: "100%", marginTop: 8 }}>
                            {formData.allowedOriginContactForm.map((origin, index) => (
                              <div
                                key={index}
                                style={{ display: "flex", gap: 8, alignItems: "center" }}
                              >
                                <Input
                                  size="large"
                                  value={origin}
                                  placeholder="https://example.com"
                                  onChange={(e) =>
                                    updateContactFormOrigin(index, e.target.value)
                                  }
                                />
                                {formData.allowedOriginContactForm.length > 1 && (
                                  <Button danger onClick={() => removeContactFormOrigin(index)}>
                                    Remove
                                  </Button>
                                )}
                              </div>
                            ))}
                          </Space>
                        </div>


                        <div className="custom-floating-label mt-3">
                          <label>Field Name</label>
                          <input
                            type="text"
                            value={formData.fieldName}
                            placeholder="Enter field name"
                            onChange={(e) => handleInputChange("fieldName", e.target.value)}
                          />
                        </div>

                        <div className="script-color-pickers d-flex justify-content-around mb-4">
                          <div>
                            <Text strong>Floating Button</Text>
                            <div style={{ marginTop: 8 }}>
                              <ColorPicker
                                value={formData.floatingButtonColor}
                                onChange={(color) =>
                                  handleColorChange(
                                    "floatingButtonColor",
                                    color
                                  )
                                }
                                showText
                                size="large"
                              />
                            </div>
                            <Text type="secondary" style={{ fontSize: "12px" }}>
                              Selected: {formData.floatingButtonColor}
                            </Text>
                          </div>
                          <div>
                            <Text strong>Button</Text>
                            <div style={{ marginTop: 8 }}>
                              <ColorPicker
                                value={formData.themeColor}
                                onChange={(color) =>
                                  handleColorChange("themeColor", color)
                                }
                                showText
                                size="large"
                              />
                            </div>
                            <Text type="secondary" style={{ fontSize: "12px" }}>
                              Selected: {formData.themeColor}
                            </Text>
                          </div>

                          <div>
                            <Text strong>Title</Text>
                            <div style={{ marginTop: 8 }}>
                              <ColorPicker
                                value={formData.headingColor}
                                onChange={(color) =>
                                  handleColorChange("headingColor", color)
                                }
                                showText
                                size="large"
                              />
                            </div>
                            <Text type="secondary" style={{ fontSize: "12px" }}>
                              Selected: {formData.headingColor}
                            </Text>
                          </div>
                        </div>

                        <Button
                          size="large"
                          block
                          type="primary"
                          onClick={handleSaveSettings}
                          loading={isSaving}
                          disabled={!generatedScript}
                          icon={<SaveOutlined />}
                        >
                          Save Settings
                        </Button>

                        {generatedScript ? (
                          <div style={{ marginTop: 16 }}>
                            <div
                              style={{
                                display: "flex",
                                flexWrap: "wrap",
                                justifyContent: "space-between",
                                alignItems: "center",
                                gap: 8,
                                marginBottom: 8,
                              }}
                            >
                              <Text strong>Generated Script</Text>
                              <div className="script-copy-buttons d-flex" style={{ gap: 6 }}>
                                <Button
                                  type="default"
                                  icon={<CopyOutlined />}
                                  onClick={handleCopyAttributesOnly}
                                >
                                  Copy Attributes
                                </Button>
                                <Button
                                  type="default"
                                  icon={<CopyOutlined />}
                                  onClick={handleCopyScript}
                                >
                                  Copy Script
                                </Button>
                              </div>
                            </div>
                            <TextArea
                              value={generatedScript}
                              readOnly
                              rows={6}
                              style={{
                                fontFamily: "monospace",
                                fontSize: "12px",
                                backgroundColor: "#f5f5f5",
                              }}
                            />
                          </div>
                        ):
                        
                         <div style={{ marginTop: 16 }}>
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                marginBottom: 8,
                              }}
                            >
                              <Text strong>Generated Script</Text>
                              {/* <Space>

                                <Button
                                  type="default"
                                  icon={<CopyOutlined />}
                                  onClick={handleCopyAttributesOnly}
                                >
                                  Copy Attributes
                                </Button>
                                <Button
                                  type="default"
                                  icon={<CopyOutlined />}
                                  onClick={handleCopyScript}
                                >
                                  Copy Script
                                </Button>
                              </Space> */}
                            </div>
                            <TextArea
                              value={"Extension is disabled. Kindly contact administrator. (Script will be generated once administrator enables the extension)."}
                              readOnly
                              rows={6}
                              style={{
                                fontFamily: "monospace",
                                fontSize: "12px",
                                backgroundColor: "#f5f5f5",
                              }}
                            />
                          </div>}
                      </Space>
                      )}
                    </Card>
                  </Col>

                  <Col xs={24} lg={12}>
                    <Card
                      className="preview-card"
                      title={
                        <Space>
                          <PhoneOutlined />
                          <span>Live Preview</span>
                        </Space>
                      }
                      bordered={false}
                    >
                      <div className="preview-container">
                        <div className="preview-description">
                          <Text type="secondary">
                            This is how the call button will appear on your
                            website:
                          </Text>
                        </div>

                        <div className="preview-button-wrapper align-items-center">
                          <button
                            className="callme-btn-preview"
                            style={{
                              backgroundColor: formData.floatingButtonColor,
                            }}
                          >
                            <svg
                              width="26"
                              height="26"
                              viewBox="0 0 24 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M20.01 15.38c-1.23 0-2.42-.2-3.53-.56-.35-.12-.74-.03-1.01.24l-1.57 1.97c-2.83-1.35-5.48-3.9-6.89-6.83l1.95-1.66c.27-.28.35-.67.24-1.02-.37-1.11-.56-2.3-.56-3.53 0-.54-.45-.99-.99-.99H4.19C3.65 3 3 3.24 3 3.99 3 13.28 10.73 21 20.01 21c.71 0 .99-.63.99-1.18v-3.45c0-.54-.45-.99-.99-.99z"
                                fill={
                                  formData.phoneIconColor === "white"
                                    ? "#fff"
                                    : "#000"
                                }
                              />
                            </svg>
                          </button>
                        </div>

                        <div
                          className="preview-description"
                          style={{ marginTop: 24 }}
                        >
                          <Text type="secondary">
                            This is how the popup will look when users click the
                            button:
                          </Text>
                        </div>

                        <div className="preview-popup">
                          <div className="callme-popup-preview">
                            <button
                              className="preview-close-btn"
                              style={{
                                position: "absolute",
                                right: "12px",
                                top: "10px",
                                border: "none",
                                background: "none",
                                fontSize: "22px",
                                color: "#999",
                                cursor: "pointer",
                                lineHeight: 1,
                              }}
                            >
                              ×
                            </button>
                            {/* <h3
                              style={{
                                color: formData.headingColor,
                                fontSize: "22px",
                                margin: "0 0 8px",
                                fontWeight: "700",
                                marginBottom: "10px",
                              }}
                            >
                              {formData.popupHeading}
                            </h3> */}
                            <p
                              style={{
                                color: "#555",
                                margin: "0 0 18px",
                                fontSize: "15px",
                              }}
                            >
                              {formData.popupText}
                            </p>
                            <div
                              style={{
                                display: "flex",
                                borderRadius: "10px",
                                border: "2px solid #eee",
                                overflow: "hidden",
                                marginBottom: "18px",
                              }}
                            >
                              <select
                                className="preview-select"
                                style={{
                                  padding: "7px 10px",
                                  background: "#f7f7f7",
                                  border: "none",
                                  minWidth: "90px",
                                  cursor: "pointer",
                                }}
                              >
                                <option value="+971">🇦🇪 +971</option>
                              </select>
                              <input
                                type="tel"
                                className="preview-input"
                                placeholder="Enter phone number"
                                readOnly
                                style={{
                                  flex: 1,
                                  padding: "7px 10px",
                                  border: "none",
                                  fontSize: "14px",
                                  outline: "none",
                                }}
                              />
                            </div>
                            <button
                              className="preview-action-btn"
                              style={{
                                width: "100%",
                                padding: "10px 14px",
                                borderRadius: "10px",
                                border: "none",
                                backgroundColor: formData.themeColor,
                                color: "#fff",
                                fontWeight: "700",
                                fontSize: "14px",
                                cursor: "pointer",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                gap: "8px",
                              }}
                            >
                              <svg
                                width="18"
                                height="18"
                                viewBox="0 0 24 24"
                                fill="none"
                              >
                                <path
                                  d="M20.01 15.38c-1.23 0-2.42-.2-3.53-.56-.35-.12-.74-.03-1.01.24l-1.57 1.97c-2.83-1.35-5.48-3.9-6.89-6.83l1.95-1.66c.27-.28.35-.67.24-1.02-.37-1.11-.56-2.3-.56-3.53 0-.54-.45-.99-.99-.99H4.19C3.65 3 3 3.24 3 3.99 3 13.28 10.73 21 20.01 21c.71 0 .99-.63.99-1.18v-3.45c0-.54-.45-.99-.99-.99z"
                                  fill={
                                    formData.phoneIconColor === "white"
                                      ? "#fff"
                                      : "#000"
                                  }
                                />
                              </svg>

                              {formData.calltoaction}
                            </button>

                            <div
                              style={{
                                marginTop: "10px",
                                fontSize: "12px",
                                color: "#555",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            >
                              {/* <img
                                src="/favicon.ico"
                                alt="VOYCELL Logo"
                                style={{
                                  width: "16px",
                                  height: "16px",
                                  marginRight: "5px",
                                  marginTop: "2px",
                                }}
                              /> */}
                              <div>Powered by</div>
                              <Link to="https://voycell.com" target="_blank"><img src="/assets/img/voycell-logo.webp" style={{height:"11px"}}></img></Link>
                            </div>
                          </div>
                        </div>

                        <div style={{ marginTop: 24 }}>
                          <Text
                            strong
                            style={{ display: "block", marginBottom: 8 }}
                          >
                            How to Use:
                          </Text>
                          <ol className="script-instructions" style={{ paddingLeft: 20, margin: 0 }}>
                            <li>
                              <Text type="secondary">
                                Configure your popup settings above
                              </Text>
                            </li>
                            <li>
                              <Text type="secondary">
                                Click "Generate Script" to create the code
                              </Text>
                            </li>
                            <li>
                              <Text type="secondary">
                                Copy the generated script snippet
                              </Text>
                            </li>
                            <li>
                              <Text type="secondary">
                                Paste it in your website's HTML before the
                                closing <code>&lt;/body&gt;</code> tag
                              </Text>
                            </li>
                          </ol>
                        </div>
                      </div>
                    </Card>
                  </Col>
                </Row>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ScriptGenerator;
